export default {
  en: {
    'pages.filing-due.title': 'Due',
    'pages.filing-processing.title': 'Processing',
    'pages.filing-preparing.title': 'Preparing',
    'pages.filing-in-review.title': 'In For Review',
    'pages.filing-send-for-filing.title': 'Send for filing',
    'pages.filing-filed.title': 'Filed',
    'pages.filing-needs-payment.title': 'Needs Payment',
    'pages.filing-this-month.title': 'This Month',
    'pages.filing-next-month.title': 'Next Month',
    'pages.filing-last-month.title': 'Last Month',
    'pages.filing-date-range.title': 'Date Range',
    'pages.filing-all.title': 'All',
    'pages.filing-due.nil_return': 'Ready to file Nil',
    'pages.filing-list.period': 'Period',
    'pages.filing.clear-all-filters': 'Clear all filters',
    'pages.filing.show': 'Show:',
    'pages.filing.download-return': 'Download return',
    'pages.filing.email-return': 'Email return',
    'pages.filing.correction': 'Correction',
    'pages.filing.correction-title': 'Are you sure you want to make a correction on this filing?',
    'pages.filing.correction-confirm': 'Yes',
    'pages.filing.correction-decline': 'No',
    'pages.filing.toggle.my-filings.view-my-filings': 'View my filings',
    'pages.filing.toggle.my-filings.view-all-filings': 'View all filings',
    'pages.filing.toggle.view.list-view': 'List view',
    'pages.filing.toggle.view.calendar-view': 'Calendar view',
  },
};
